import type { JSX } from '@builder.io/qwik';
import { useContext } from '@builder.io/qwik';
import { component$ } from '@builder.io/qwik';
import { ArticleContext } from '~/contexts/ArticleContext';

/**
 * Bottom Placeholder
 *
 * Area for advertisements to be injected
 */
export default component$((): JSX.Element => {
  const article = useContext(ArticleContext);

  const theId =
    article?.finiteScrollNumber && article.finiteScrollNumber > 0
      ? `bottom-placeholder-${article.finiteScrollNumber}`
      : 'bottom-placeholder';

  // Check if ads are disabled on article
  if (
    article?.metadata?.commercialTags &&
    article.metadata.commercialTags.includes('no-ads')
  )
    return <></>;

  return <div id={theId} class='bottom-placeholder' />;
});
